import { StoreActionType as Type } from "../../types";

export interface SetNavigateUrlsAction {
    type: typeof Type.SET_NAVIGATE_URLS;
    payload: string[];
}

export const setNavigateUrls = (urls: string[]): SetNavigateUrlsAction => ({
    type: Type.SET_NAVIGATE_URLS,
    payload: urls
});

export type AuthorizationActionTypes = SetNavigateUrlsAction; 